import { render, staticRenderFns } from "./DiagramViewer.vue?vue&type=template&id=bb3215fc&scoped=true"
import script from "./DiagramViewer.vue?vue&type=script&lang=js"
export * from "./DiagramViewer.vue?vue&type=script&lang=js"
import style0 from "./DiagramViewer.vue?vue&type=style&index=0&id=bb3215fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3215fc",
  null
  
)

export default component.exports